import { compose } from 'recompose';
import CreateGrn from './CreateGrn';
import withRequestTracker from '../../../../utils/composition/withRequestTracker';
import {
  query, mutation, CREATE_GRN, UPDATE_GRN, APPROVE_GRN
} from './API';
import { UPLOAD } from '../../../common/GqlAPI';
// import { grnImageUploader } from '../../../../utils/image';

const ComposedCreateGrn = compose(
  UPLOAD,
  CREATE_GRN,
  UPDATE_GRN,
  APPROVE_GRN,
  withRequestTracker({
    query,
    mutation,
  }),
  // grnImageUploader,
)(CreateGrn);

export default ComposedCreateGrn;
